/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Telefone profissional',
  [phoneTypes.extension]: 'Número de extensão',
  [phoneTypes.home]: 'Número de casa',
  [phoneTypes.mobile]: 'Telemóvel',
  [phoneTypes.phone]: 'Telefone',
  [phoneTypes.unknown]: 'Tipo de telefone desconhecido',
  [phoneTypes.company]: 'Número da empresa',
  [phoneTypes.direct]: 'Número direto',
  [phoneTypes.contact]: 'Telefone de contacto',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Outro',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
